import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LOGO =
  "https://customer-assets.emergentagent.com/job_f3a45add-178a-4654-a651-71bba623af6b/artifacts/2b5l1hfl_Sagitta.png";

const links = [
  { href: "#nosotros", label: "Nosotros" },
  { href: "#distintivos", label: "Distintivos" },
  { href: "#servicios", label: "Servicios" },
  { href: "#clientes", label: "Clientes" },
  { href: "#testimonios", label: "Testimonios" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-neutral-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3"
        >
          <img
            src={LOGO}
            alt="Sagitta Corporativo"
            className="h-10 w-10 object-contain"
          />
          <div className="leading-tight hidden sm:block">
            <div className="font-serif-display text-[15px] font-semibold tracking-wide">
              SAGITTA
            </div>
            <div className="text-[10px] font-medium tracking-[0.32em] text-neutral-500">
              CORPORATIVO
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="link-underline text-sm font-medium text-neutral-700 hover:text-neutral-950 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#contacto"
            data-testid="nav-cta-contact"
            className="btn-shine hidden md:inline-flex items-center gap-2 bg-[#0A0A0A] text-white px-5 py-3 text-sm font-medium tracking-wide hover:bg-[#E97906] transition-colors duration-300"
          >
            Contáctanos
            <span aria-hidden>→</span>
          </a>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 text-neutral-900"
            aria-label="Menú"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden bg-white border-t border-neutral-200 transition-[max-height] duration-500 ${
          open ? "max-h-[460px]" : "max-h-0"
        }`}
      >
        <div className="px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-link-${l.href.replace("#", "")}`}
              className="text-base text-neutral-800 py-1"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contacto"
            onClick={() => setOpen(false)}
            data-testid="mobile-nav-cta-contact"
            className="mt-2 inline-flex justify-center bg-[#E97906] text-white px-5 py-3 text-sm font-semibold"
          >
            Contáctanos
          </a>
        </div>
      </div>
    </header>
  );
}
